import React from "react";

import BannerCheckList from "../../../../common/BannerCheckList";
import CountdownTimer from "../../Homepage/components/CountdownTimer";
import FormatCurrency from "../../Homepage/components/FormatCurrency";

const Bonus = ({ currentOffer, locale, translate }) => {
  const checklistItems =
    currentOffer?.bonus?.items?.map(({ title, description, value }) => ({
      key: title,
      title: title || null,
      description: description || null,
      meta:
        value > 0 ? (
          <span className="text-xs.1 text-white font-medium opacity-60">
            {translate("plans_bonus_value")}
            <FormatCurrency locale={locale} value={value} />
          </span>
        ) : null
    })) ?? [];

  return (
    <div className={"rounded-2xl bg-banner flex px-4.5 pb-4.5 pt-6"}>
      {currentOffer.bonus.image ? (
        <img
          className={"-mt-16"}
          width={220}
          height={220}
          src={currentOffer.bonus.image}
          alt={""}
        />
      ) : null}
      <div className={"w-full"}>
        <h2 className={"text-xl.1 mb-6.1"}>
          <span className={"text-yellow"}>
            {translate("plans_bonus_heading")}
          </span>
          <span className={"font-bold text-white"}>
            {currentOffer.bonus.plans.join(", ")}
          </span>
        </h2>
        <div className={"flex justify-between align-end"}>
          <BannerCheckList
            items={checklistItems}
            titleSize="lg"
            descriptionSize="sm"
          />
          {currentOffer.bonus?.expires_on ? (
            <div className={"gap-3 flex flex-col"}>
              <span
                className={
                  "font-semibold text-xs opacity-60 text-white uppercase text-right mr-1.5"
                }
              >
                {translate("plans_bonus_time-left")}
              </span>
              <div className={"flex box-1 gap-4 max-w-2xl.3"}>
                <CountdownTimer
                  targetTime={new Date(currentOffer.bonus.expires_on).getTime()}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Bonus;
